const formatDateUTC = (inputDate) => {
    const date = new Date(inputDate);

    const monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
    // Changed to UTC methods
    const dayOfMonth = date.getUTCDate();
    const daySuffix = ["th", "st", "nd", "rd"][
        dayOfMonth % 10 === 1 &&
        dayOfMonth !== 11 ? 1 :
        dayOfMonth % 10 === 2 &&
        dayOfMonth !== 12 ? 2 :
        dayOfMonth % 10 === 3 &&
        dayOfMonth !== 13 ? 3 : 0
    ];
    // Changed to UTC method
    const monthName = monthNames[date.getUTCMonth()];

    const outputDate = `${monthName} ${dayOfMonth}${daySuffix}`;

    return outputDate;
};

export default formatDateUTC;